import _forEach from 'lodash/forEach';
import _map from 'lodash/map';
import _find from 'lodash/find';
import swal from 'sweetalert';
import {toastr} from 'react-redux-toastr';
import {errorToastrOptions} from '../../config';
import {MAX_CHARS_LENGTH_FOR_REVIEW_AJAX_CALL} from './constants';

export const getSortName = (sorted) => {
   let sortName = _map(sorted, 'id');

   return sortName;
};

export const getSortOrder = (sorted) => {
    let sortOrder = _map(sorted, (key) => key.desc ? 'asc' : 'desc');

   return sortOrder;
};

export const getFilters = filtered => {
    let filters = '';
    _forEach(filtered, filter => {
       filters += '&' + filter.id + '=' + encodeURIComponent(filter.value);
    });

   return filters;
};

export const comparer = (items) => {
    return current => {
        return items.filter(other => {
            return other.id === current.id
        }).length === 0;
    }
};

export const getDisplayNameOrNull = (option) => {
    return option === null ? ' - ' : option;
};

export const cutLongStrings = (string) => {
    return string.length > 150 ? string.substr('>', 150) + '...' : string;
};

export const displayStaffArrays = (array) => {

    const arrayItems = array.map(
        item => item.destination_name ? item.destination_name : item.display_name).join(", ");

    return arrayItems.length > 1 ? arrayItems : '-'

}

export const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
};

export const b64toBlob = (b64Data, sliceSize=512) => {

    let arr = b64Data.split(','), mime = arr[0].match(/:(.*?);/)[1];

    const byteCharacters = atob(arr[1]);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, {type: mime});

    return blob;
};

export function toDataUrl(url, callback) {
    let xhr = new XMLHttpRequest();
    xhr.onload = () => {
        let reader = new FileReader();
        reader.onloadend = () => {
            callback(reader.result);
        };
        reader.readAsDataURL(xhr.response);
    };
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.send();
}

export function errors_popup(error) {
    let errStr = '';

    if (error.response !== undefined) {
        if (error.response && error.response.data && error.response.data.errors) {
            error.response.data.errors.forEach(err => {
                for (let key in err) {
                    errStr += err[key] + "\r\n";
                }
            });
        } else if (error.response && error.response.data && error.response.data.error) {
            errStr = error.response.data.error;
        }
    }

    if (errStr === '') {
        errStr = error.response.data.message;
    }

    if (error.response.statusText === "Forbidden") {
        errStr = "You do not have permissions for this content!";
    }

    return errStr;
}

export function getArrays(updateArray) {
    let updateDataArray = [];

    Object.entries(updateArray).forEach(([index, item]) => {
        let itemId = item.id;
        updateDataArray.push({
            id: itemId
        });
    });

    return updateDataArray;
}

export function convertArrayOfObjectsToCSV(array) {
    let result, counter, keys, columnDelimiter, lineDelimiter, data;

    data = array.data || null;
    if (data == null || !data.length) {
        return null;
    }

    columnDelimiter = array.columnDelimiter || ',';
    lineDelimiter = array.lineDelimiter || '\n';

    keys = Object.keys(data[0]).filter(key => key !== 'error_message');

    result = '#';
    result += keys.join(columnDelimiter);
    result += lineDelimiter;

    data.forEach(item => {
        counter = 0;
        keys.forEach(key => {
            if (counter > 0) {
                result += columnDelimiter;
            }
            if (key !== 'error_message') {
                result += item[key];
            }
            counter++;
        });
        result += lineDelimiter;
    });

    return result;
}

export function downloadCSV(array) {
    let link;
    let csv = convertArrayOfObjectsToCSV({
        data: array
    });

    if (csv == null) return;

    if (!csv.match(/^data:text\/csv/i)) {
        csv = 'data:text/csv,' + csv;
    }

    link = document.createElement('a');
    link.setAttribute('href', csv);
    link.setAttribute('download', 'redirects.csv');
    link.click();
}

export function getFilteredDataById(array, id) {

    let filteredArray = array.filter(item => item.id === id);

    return filteredArray.pop();
}

export function getFilteredDataBySiteId(array, siteId) {

    let filteredArray = array.filter(item => item.site_id === siteId);

    if (!filteredArray.length) {
        return null;
    }

    return filteredArray.pop();
}

export function splitAndShowLocalDateTime(dateTime) {
    dateTime = new Date(dateTime + 'Z');
    let date = dateTime.toLocaleDateString('en-GB');
    let time = dateTime.toLocaleTimeString();

    return date + ', ' + time;
}

export function showToasterWarningMessage(message) {
    toastr.warning('Attention!', message, errorToastrOptions)
}

export function showToasterInfoMessage(message) {
    toastr.info('Info!', message, errorToastrOptions)
}

export function showToasterErrorMessage(message) {
    toastr.error('Warning!', message, errorToastrOptions)
}

export function showToasterLightMessage(message) {
    const toastrType = 'info';
    const toastrLightOptions = {
        timeOut: 0,
        removeOnHover: false,
        newestOnTop: true,
        icon: toastrType,
        status: toastrType
    }
    toastr.light('Info!', message, toastrLightOptions)
}

export function showErrMsgPopup(errMsg) {
    swal("There were some errors", errMsg, "error");
}

export const getSearchValues = (filters, filterName) => {
    let search = _find(filters, {id: filterName});
    let searchValue = search && search.value;

    return searchValue;
}

export const handleCopyPasteTextInEditor = () => {
    document.addEventListener('copy', event => {
        let copiedHtml = "";
        let selection = window.getSelection().getRangeAt(0).cloneContents();
        let temp = document.createElement('div');
        temp.appendChild(selection);
        copiedHtml = temp.innerHTML;
        event.clipboardData.setData('text/html', copiedHtml);
        event.preventDefault();
    });

    document.addEventListener('paste', event => {
        event.clipboardData.getData('text/html');
    });
}

/**
 * Projects Abroad CMS used to use Quill editor, which encouraged extra blank new lines
 * This logic is also in use on the public-facing websites
 * In time, perhaps it can be removed
 *
 * Regex matches the folling HTML whilst allowing for white space, and optional HTML attributes:
 * `<p><br/></p>`
 */
export const removeBlankParagraphs = (html) => {
    if (typeof html !== "string") {
        return html;
    }

    return html.replace(/<p(?: [^>]*)?>\s*<br(?: [^>]*)?\s*\/?>\s*<\/p>/gi, '');
}

export const lengthInUtf8Bytes = (str) => {
    // Matches only the 10.. bytes that are non-initial characters in a multi-byte sequence.
    var m = encodeURIComponent(str).match(/%[89ABab]/g);

    return str.length + (m ? m.length : 0);
}

export const hasTheNecessaryLenghtForAjaxCall = (str) => {
    return lengthInUtf8Bytes(str) > MAX_CHARS_LENGTH_FOR_REVIEW_AJAX_CALL;
}


// WEBPACK FOOTER //
// ./src/components/helpers/helpers.js